import {
    request
} from '../lib/http_request'
import {
    apis
} from '../lib/apis'

// 保存活动
const saveActivity = obj => new Promise((resolve, reject) => {
    const {
        createForm,
        token
    } = obj;
    request({
        url: apis.activity_save + '?token=' + token,
        data:createForm
    }).then(res => {
        resolve(res);
    })
})

// 开启\关闭活动
const temporarilyClosedActivity = obj => new Promise((resolve, reject) => {
    const {
        temporarilyClosedForm,
        token
    } = obj;
    request({
        url: apis.activity_temporarily_closed + '?token=' + token,
        data:temporarilyClosedForm
    }).then(res => {
        resolve(res);
    })
})

// 开启\关闭活动
const recoverActivity = obj => new Promise((resolve, reject) => {
    const {
        recoverForm,
        token
    } = obj;
    request({
        url: apis.activity_recover + '?token=' + token,
        data:recoverForm
    }).then(res => {
        resolve(res);
    })
})

// 开启\关闭活动
const closedActivity = obj => new Promise((resolve, reject) => {
    const {
        closedForm,
        token
    } = obj;
    request({
        url: apis.activity_closed + '?token=' + token,
        data:closedForm
    }).then(res => {
        resolve(res);
    })
})

// 开启\关闭活动
const delActivity = obj => new Promise((resolve, reject) => {
    const {
        delForm,
        token
    } = obj;
    request({
        url: apis.activity_del + '?token=' + token,
        data:delForm
    }).then(res => {
        resolve(res);
    })
})

const timeActivityRefresh = obj => new Promise((resolve, reject) => {
    const {
        refreshForm,
        token
    } = obj;
    request({
        url: apis.activity_time_refresh + '?token=' + token,
        data:refreshForm
    }).then(res => {
        resolve(res);
    })
})




export default {
    saveActivity,
    temporarilyClosedActivity,
    recoverActivity,
    closedActivity,
    delActivity,
    timeActivityRefresh,
}



// WEBPACK FOOTER //
// ./src/service/activity_api.js